module.exports = __webpack_public_path__ + "static/conflict_card_img5@2x-5b90f63030840e6689a7a29fc0c617b9.png";